import { graphql } from "../../shared/schema/gql";

/**
 * The Clock In & Out (New) row, for just the visits a dashboard page is showing.
 * `visitInstanceIds` makes the server ignore the date range.
 */
export const GET_EVV_DEV_HELP_VISIT_DETAILS_QUERY = graphql(`
  query GetEvvDevHelpVisitDetails($visitInstanceIds: [VisitInstanceId!], $limit: Int!) {
    clockedVisitInstances(
      limit: $limit
      offset: 0
      order: []
      visitInstanceIds: $visitInstanceIds
    ) {
      nodes {
        id
        startTime
        endTime
        patientId
        caregiverId
        clockinTime
        clockoutTime
        clockinType
        clockoutType
        patient {
          id
          firstName
          middleName
          lastName
        }
        caregiver {
          id
          firstName
          middleName
          lastName
        }
        contract {
          id
          contractType {
            id
            name
            evvAggregator
          }
        }
        serviceCode {
          id
          code
        }
        emednySubmission {
          transactionId
          submitted
          processedAt
          errorType
          errors
        }
        tellusSubmission {
          createdAt
          submitted
          errorCodes
        }
        sandataSubmission {
          submittedAt
          completed
          errors
        }
        hhaexchangeSubmission {
          submitted
          sentAt
          errorType
          errorMessage
          transactionId
        }
      }
    }
  }
`);
